
import { Box, IconButton } from '@material-ui/core'
import { AddBox, Visibility as ViewIcon } from '@material-ui/icons'
import tableIcons, { options } from 'components/universal/table_attributes'
import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import PartSalesServices from 'lib/services/api/commercial/parts'
import { getOrganisationId, getColors } from 'lib/utils/common_utils'
import CommercialIcon from 'assets/Commercial/Sales'
import TickIcon from 'assets/Commercial/Tick'


export default function SaleTable(props) {
    const { currrencyDetails,
        quotationId, quotationDetails, disabled } = props
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentSelection, setCurrentSelection] = useState({})



    const tableOptions = {
        ...options,
        paging: false,
        search: false,
        toolbar: false
    }

    const getDetails = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            sales_order_id: quotationId

        }
        try {
            const response = await PartSalesServices.getQuoteSaleItemDetails(params)
            setData(response?.data)
        } catch (error) {

        }
    }
    useEffect(() => {
        if (quotationId !== null) {


            getDetails()

        }
    }, [quotationId])


    const renderStateIcon = (rowData) => {

        const Icon = {
            0: <CommercialIcon fill={getColors("amber")} />,
            1: <CommercialIcon fill={getColors("green")} />,
            2: <TickIcon fill={getColors("green")} />,



        }

        return Icon[rowData?.state]

    }





    const columns = [{
        title: "State",
        field: "part",
        width: "15%",
        render: (rowData) => renderStateIcon(rowData)
    },
    {
        title: "Part #",
        field: "part",
        width: "15%",
        headerStyle: {
            textAlign: "left",
            paddingLeft: "15px"
        },
        cellStyle: {
            textAlign: "left",
            paddingLeft: "15px"
        }
    },
    {
        title: "Description",
        field: "description",
        width: "25%",
        headerStyle: {
            textAlign: "left",
            width: "25%",
        },
        cellStyle: {
            textAlign: "left",
            width: "25%",
        }
    },
    {
        title: "Unit Price",
        field: "unit_cost"
    }, {
        title: "Quantity",
        field: "quantity"
    }, {
        title: "Total",
        field: "total"
    }, {
        title: "Currency",
        field: "currency"
    },
    {
        title: "Lead Days",
        field: "led_day"
    },



    ]






    return (
        <Box mb={"20px"}>

            <MaterialTable
                options={tableOptions}
                icons={tableIcons}
                data={data || []}
                columns={columns}
                isLoading={""}
                title={""}



            />





        </Box>
    )
}
